import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { useAuth } from '../../../../../config/AuthProvider/authProvider';
import { LOANS_INFO } from '../../../../../config/cacheKey';
import LayoutWithoutDrawer from '../../../../../layouts/LayoutWithoutDrawer';
import { setHeaderTitle } from '../../../../../redux/headerTitle/headerTitleSlice';
import DrawerBody from '../../../../requestSteps/drawerBody/drawerBody';
import Payment from '../../../../requestSteps/inquiryFee/resultPayment/payment';
import AssignedLoans from '../assignedLoans/assignedLoans';
import FutureLoans from '../assignedLoans/futureLoans';
import CanceledLoans from '../canceldLoans/CanceledLoans';
import InstallmentPayment from '../../../../requestSteps/inquiryFee/resultPayment/installmentPayment';
import VerticalySplittedLayout from '../../../../../components/layouts/verticalySplittedLayout';
import AssignedLoanCard from '../../../../../components/card/DrawerCards/AssignedLoanCard';
import { AppBarProvider } from '../../../../../components/appBar/appBarContext';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';


const InstallmentsContainer = () => {
    const navigate = useNavigate();
    const { referenceKey, setRefKey } = useAuth();
    const dispatch = useDispatch();
    const queryClient: any = useQueryClient()
    const loanRequestStatus = queryClient.getQueryData(LOANS_INFO)

    const headerConfig: Record<string, { color: string, header: string }> = {
        'Assigned': { color: "var(--bg-loan-card)", header: "اطلاعات اقساط" },
        'CanceledBySetad': { color: "var(--bg-loan-card)", header: "لغو شده توسط کارشناس" },
        'default': { color: "var(--bg-loan-card)", header: "پرداخت اقساط" }
    };
    const myUrl = queryClient.getQueryData("URL_PARAMS") as any

    useEffect(() => {
        const { color, header } = headerConfig[loanRequestStatus?.loanRequestStatus] || headerConfig['default'];
        dispatch(
            setHeaderTitle({
                color,
                header,
                parentRoute: 'loans',
            })

        );

    }, [])
    const setState = (state: string) => navigate(`/loans/installments/${state === 'AssignedLoans' ? '' : state}`);
    return (
        <Routes>
            <Route index element={<VerticalySplittedLayout top={<AssignedLoanCard />} bottom={
                    <AppBarProvider>
                        <AssignedLoans referenceKey={referenceKey!} setStep={setState} />
                    </AppBarProvider>
                } />} />
            <Route path="payment" element={<LayoutWithoutDrawer><Payment referenceKey={referenceKey!} setStep="payment" parentRoute='AssignedLoans' /></LayoutWithoutDrawer>} />
            <Route path="FutureLoans" element={<VerticalySplittedLayout top={<AssignedLoanCard />} bottom={
                    <AppBarProvider>
                        <FutureLoans referenceKey={referenceKey!} setStep={setState} />
                    </AppBarProvider>
                } />} />
            <Route path="CanceledLoans" element={<DrawerBody isAssigned><CanceledLoans /></DrawerBody>} />
            <Route path="installmentPayment" element={<LayoutWithoutDrawer><InstallmentPayment setState={setState} referenceKey={referenceKey!} /></LayoutWithoutDrawer>} />
            <Route path="*" element={<Navigate to="/loans/installments" replace />} />
        </Routes>
    )
}

export default InstallmentsContainer
